import React, { Component } from "react";
import Modal from "@acadia-ui/modal";
import Button from "@acadia-ui/button";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import "./DeletePlacements.scss";

class DeleteModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.deleteModal(this);
	}

	componentWillUnmount() {
		this.props.deleteModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (event) {
			if (!event.currentTarget.classList.contains("bx--modal")) {
				ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
			}
		} else {
			ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
		}
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open });
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.deleteFunction();
		this.triggerOpenClose();
	};

	render() {
		const label = `Delete ${this.props.type}`;

		const selectedUniqueIDs = this.props.data.map((row) => {
			return row.UniqueID;
		});

		const selectedLines = JSON.parse(JSON.stringify(PlacementDataStore.getData()))
			.map((row, index) => {
				row.Row = index;
				return row;
			})
			.filter((row) => {
				return selectedUniqueIDs.includes(row.UniqueID);
			});

		return (
			<Modal
				className="deletePlacementModal"
				id="deletePlacementModal"
				description="The selected placements will be permanently deleted and cannot be undone."
				heading={label}
				isOpen={this.state.open}
				// onSecondarySubmit={this.triggerOpenClose}
				// onRequestSubmit={this.handleSubmit}
				onRequestClose={() => {
					if (this.state.open) {
						this.triggerOpenClose();
					}
				}}
				size="medium"
				userClosable={false}
				actionSetProps={{
					actionsRight: (
						<>
							<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-delete-placement">
								Cancel
							</Button>
							<Button className="third-button" display="primary" onClick={this.handleSubmit} data-tracking-id-alt="confirm-delete-placement">
								Confirm
							</Button>
						</>
					)
				}}
				onClick={() => {}}
			>
				<div className="placementListContainer">
					<div className="placementListHeader">
						<span>Description</span>
						<span>Package</span>
						<span>Site</span>
						<span>Start Date</span>
						<span>End Date</span>
						<span>Cost</span>
					</div>

					{selectedLines.map((line, i) => (
						<div className="placementInfoRow" key={`deleteplacementline-${i}`}>
							<span className="placementInfo">{line.PlacementDescription}</span>
							<span className="placementInfo">{line.ParentDescription}</span>
							<span className="placementInfo">{line.InNameSite}</span>
							<span className="placementInfo">{line.StartDate}</span>
							<span className="placementInfo">{line.EndDate}</span>
							<span className="placementInfo">{line.Cost}</span>
						</div>
					))}
				</div>
				{this.props.placementAPI === true && (
					<>
						<p style={{ fontSize: "17px", marginTop: "5px", fontWeight: "bold" }}>
							Deleting a placement that has been successfully synced also requires manually archiving within Google Campaign Manager.
						</p>
					</>
				)}
				{this.props.prismaAPIEnabled === true && (
					<p style={{ fontSize: "17px", marginTop: "5px", fontWeight: "bold" }}> Deleting placements in PM will automatically exclude them within Prisma.</p>
				)}
			</Modal>
		);
	}
}
export default DeleteModal;
